// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".list-item-info{padding-left:0;list-style:none;display:flex;overflow-x:scroll;font-size:.875rem;white-space:nowrap}.list-item-info::-webkit-scrollbar{display:none}.list-item-info,.list-item-info .icon,.list-item-info a{color:rgba(var(--bs-body-color-rgb),.75)}.list-item-info li+li{margin-left:.5rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
